import type { NotAllowedToSignInReason } from "@glide/common-core";
import { getLocalizedString } from "@glide/localization";

export function getNotAllowedToSignInMessage(reason: NotAllowedToSignInReason | undefined): string {
    if (reason === "non-personal-email-not-allowed") {
        return "Please use a personal email or upgrade to the Business plan.";
    }

    return getLocalizedString("emailAddressDoesntHaveAccess");
}
